export const CONTACT_INFO = {
  email: "support@eternalorder.in",
  phone: "6304547946",
  whatsapp: "6304547946",
  instagram: "shop.eternalorder",
  facebook: "Eternal Order",
  facebook_url: "https://facebook.com",
};

export const HERO_SLIDES = [
  {
    id: "intro",
    image: "/assets/intro-tile1.png",
    to: "/shop",
  },
  {
    id: "madhav",
    image: "/assets/madhav-tile2.png",
    to: "/collections/madhav",
  },
  {
    id: "shiva",
    image: "/assets/shiva-tile3.png",
    to: "/collections/shiva",
  },
  {
    id: "maryada",
    image: "/assets/maryada-tile4.png",
    to: "/collections/maryada",
  },
  {
    id: "anjaneya",
    image: "/assets/anjaneya-tile5.png",
    to: "/collections/anjaneya",
  },
  {
    id: "customize",
    image: "/assets/customize-tile6.png",
    to: "/customize",
  },
];

export const NOW_LIVE_CARDS = [
  {
    id: "maryada",
    name: "Maryada",
    image: "/assets/whats-new-maryada.png",
    to: "/collections/maryada",
  },
  {
    id: "madhav",
    name: "Madhav",
    image: "/assets/whats-new-madhav.png",
    to: "/collections/madhav",
  },
  {
    id: "shiva",
    name: "Shiva",
    image: "/assets/whats-new-shiva.png",
    to: "/collections/shiva",
  },
  {
    id: "veergatha",
    name: "Veergatha",
    image: "/assets/whats-new-veergatha.png",
    to: "/collections/veergatha",
  },
  {
    id: "anjaneya",
    name: "Anjaneya",
    image: "/assets/whats-new-anjaneya.png",
    to: "/collections/anjaneya",
  },
  {
    id: "customize",
    name: "Customize Your Drip",
    image: "/assets/whats-new-customize.png",
    to: "/customize",
  },
  {
    id: "acid",
    name: "Acid Wash Premium",
    image: "/assets/whats-new-acid-wash-premium.png",
    to: "/collections/acid-wash-premium",
  },
];

export const NAV_ITEMS = [
  { label: "Home", to: "/" },
  { label: "Shop the Drop", to: "/shop" },
  { label: "Acid Wash Premium T-shirts", to: "/collections/acid-wash-premium" },
  { label: "Customize Your Drip", to: "/customize" },
  { label: "About", to: "/about" },
  { label: "Contact Us", to: "/contact" },
];

export const SHOP_DROPDOWN_ITEMS = [
  { label: "Shiva", to: "/collections/shiva" },
  { label: "Veergatha", to: "/collections/veergatha" },
  { label: "Madhav", to: "/collections/madhav" },
  { label: "Maryada", to: "/collections/maryada" },
  { label: "Anjaneya", to: "/collections/anjaneya" },
];

export const COLLECTION_COPY = {
  madhav: {
    title: "MADHAV",
    subtext: "The Krishna aesthetic, interpreted through Eternal Order.",
    intro:
      "A collection inspired by grace, charm, and timeless presence. Madhav brings together symbolic storytelling and elevated design through a modern lens.",
    gridTitle: "SHOP MADHAV",
    line: "Madhur. Mohak. Murali.",
  },
  shiva: {
    title: "SHIVA",
    subtext: "A tribute to stillness, power, and cosmic intensity.",
    intro:
      "Rooted in the energy of Shiva, this collection explores strength, silence, and depth through bold forms and striking visual language.",
    gridTitle: "SHOP SHIVA",
    line: "Adi. Anant. Bhole.",
  },
  veergatha: {
    title: "VEERGATHA",
    subtext: "Stories of courage and sacrifice, translated into wearable expression.",
    intro:
      "A tribute to valor, resolve, and timeless spirit. VEERGATHA carries the energy of warrior legacies into everyday silhouettes.",
    gridTitle: "SHOP VEERGATHA",
    line: "Veer. Vachan. Vijay.",
  },
  maryada: {
    title: "MARYADA",
    subtext: "Discipline, honor, and timeless character.",
    intro:
      "Maryada draws from values of restraint, clarity, and strength. This collection reflects a more grounded expression of Eternal Order through purposeful design.",
    gridTitle: "SHOP MARYADA",
    line: "Discipline. Honor. Legacy.",
  },
  anjaneya: {
    title: "ANJANEYA",
    subtext: "Devotion, courage, and unwavering force.",
    intro:
      "Inspired by fearless service and strength in motion, Anjaneya brings power and conviction into forms designed for everyday expression.",
    gridTitle: "SHOP ANJANEYA",
    line: "Ramdoot. Veer. Bajrangi.",
  },
  "acid-wash-premium": {
    title: "ACID WASH PREMIUM",
    subtext: "Plain, elevated, and built with attitude.",
    intro:
      "A clean essential with texture, depth, and edge. Designed for everyday wear, our acid-wash premium tees bring a refined finish to simple silhouettes.",
    gridTitle: "SHOP ACID WASH PREMIUM",
    line: "",
  },
};

export const POLICY_CONTENT = {
  shipping: {
    title: "SHIPPING POLICY",
    content: `Eternal Order ships orders from Hyderabad, Telangana, India to serviceable locations across India.
Our shipments are generally processed through NimbusPost, which may allocate an appropriate courier partner based on serviceability, location, shipment specifications, cost, and courier performance. NimbusPost supports nationwide shipping, tracking, NDR management and delivery communications through its courier network.
Order Processing
Orders are generally processed within 1–3 business days after successful order confirmation.
Orders placed on Sundays, public holidays, or during major sale/drop periods may require additional processing time.
Once dispatched, customers will receive available tracking details by email, SMS, WhatsApp, or another communication method associated with the order.
Estimated Delivery
Typical delivery after dispatch is approximately:
Metro / major cities: 2–5 business days
Other serviceable locations: 4–7 business days
Remote or difficult-to-service locations: approximately 5–10 business days
These are estimates and not guaranteed delivery dates.
Actual delivery time may depend on destination PIN code, courier partner, weather, public holidays, operational disruptions, incorrect address details, delivery attempts, or other circumstances outside Eternal Order’s reasonable control. NimbusPost also notes that delays can arise from incorrect addresses, high volumes, transit delays and missed delivery attempts.
Shipping Charges
Applicable shipping charges, if any, will be displayed at checkout before payment.
Free-shipping promotions may apply subject to the terms shown on the website at the time of purchase.
COD
Cash on Delivery may be available for eligible PIN codes and orders.
COD availability may depend on serviceability and our fraud/RTO-prevention checks.
We may contact customers to confirm COD orders before dispatch.
Tracking
Once an order is shipped, tracking information will be shared where available.
NimbusPost provides shipment tracking through its logistics network, and customers may also receive branded tracking or courier notifications.
Failed Delivery / NDR
If a courier is unable to deliver your order, additional delivery attempts may be made depending on the courier partner.
Customers should respond promptly to courier calls, SMS, WhatsApp or NDR confirmation requests.
Failure to provide correct contact information, repeated non-response, incorrect addresses, or refusal of a confirmed shipment may result in the order being returned to us.
Address Changes
Please contact us as soon as possible if you notice an error in the shipping address.
Once a shipment has been dispatched or handed to the courier, we cannot guarantee that an address change can be made.
Lost or Damaged Shipments
If tracking shows delivered but you have not received the shipment, contact us promptly so we can investigate with the logistics provider. NimbusPost similarly directs recipients with missing delivered packages to contact the merchant.
If a shipment is confirmed lost or materially damaged in transit, Eternal Order will determine an appropriate replacement or refund after investigation.
Delays
While we aim to dispatch and deliver orders within the estimated timeframes, courier delays can occasionally occur.
Where an order is delivered materially later than the stated delivery schedule, applicable consumer-law rights remain unaffected.
Order Cancellation
Orders may be cancelled before dispatch by contacting us.
Once an order has been shipped, it generally cannot be cancelled as a normal pre-dispatch cancellation and may instead need to follow the applicable return process after delivery.
Shipping Support
For shipping or tracking queries, contact:
Eternal Order
Hyderabad, Telangana, India
Email: support@eternalorder.in
WhatsApp/Phone: +91-6304547946`,
  },
  returns: {
    title: "RETURN POLICY",
    content: `We want every Eternal Order product to reach you in the condition and size you expected. Eligible return or exchange requests may be raised within 7 calendar days from the date of delivery.
To qualify for a return or exchange, the product must be unused, unwashed, unworn other than for reasonable trial, unaltered, free from stains, perfume, deodorant or other signs of use, and returned with its original tags and packaging intact.
Size Exchanges
If you ordered the wrong size or would prefer another size, you may request an exchange within 7 days of delivery, subject to stock availability.
For ordinary size exchanges or preference-based exchanges, a reverse-shipping fee of ₹99 may apply.
If the requested size is unavailable, we may offer another available option or an eligible refund.
Change-of-Mind Returns
Eligible returns due solely to preference, fit, or change of mind may be accepted within the 7-day window.
A ₹99 reverse-logistics charge may be deducted from the refund.
Any original shipping charge separately paid at checkout may not be refundable for a preference-based return.
Wrong, Damaged or Defective Products
If you receive an incorrect product, incorrect size supplied by us, manufacturing defect, damaged item, or product materially different from what was ordered, contact us preferably within 48 hours of delivery.
Please provide your order number and clear photographs. An unboxing video may help us investigate transit-related damage, but statutory consumer rights will not be denied merely because an unboxing video is unavailable.
Once the issue is verified, Eternal Order will arrange an eligible replacement or refund and bear the applicable reverse-shipping cost.
Under India’s Consumer Protection (E-Commerce) Rules, sellers and inventory e-commerce entities must clearly disclose return/refund terms and cannot refuse take-back/refund for goods that are defective, deficient, spurious, not as advertised/agreed, or delivered beyond the stated schedule except where applicable exceptions such as force majeure apply.
Reverse Pickup
Where serviceable, eligible reverse pickups may be arranged through NimbusPost or one of its courier partners. NimbusPost supports reverse logistics and reverse pickup across supported pin codes.
Reverse pickup availability depends on the pickup PIN code and courier serviceability.
If reverse pickup is unavailable, we may ask you to self-ship the product to our designated Hyderabad return address. For a verified wrong, damaged, or defective item attributable to us, reasonable return-shipping costs may be reimbursed subject to verification.
Return Inspection
All returned products are inspected after receipt.
A return may be rejected if the item is washed, worn, altered, stained, damaged after delivery, missing tags, or otherwise does not meet the eligibility conditions above, except where applicable consumer law requires a remedy.
Refunds
Once an eligible returned product reaches us and passes inspection, the refund will generally be initiated within 5–7 business days.
Prepaid orders will ordinarily be refunded to the original payment method.
For COD orders, we may request verified UPI or bank details to process the refund.
Your bank or payment provider may require additional time to reflect the amount after we initiate it.
Non-Returnable Items
Unless defective, incorrectly supplied, or otherwise required by applicable law, the following may be excluded from preference-based returns:
customised or personalised products; washed or worn garments; altered products; products damaged after delivery; and products returned without original tags.
COD Refusal / RTO
Customers are requested to provide accurate delivery details and accept confirmed COD orders.
Repeated refusal of confirmed COD shipments, repeated avoidable delivery failures, or repeated use of incorrect address/contact details may result in COD being restricted for future orders.
NimbusPost provides NDR and address/order-verification tools that can help manage unsuccessful deliveries and RTOs.
Raising a Return or Exchange
Contact us at:
Email: support@eternalorder.in
WhatsApp/Phone: +91-6304547946
Please include:
Order number + registered phone/email + item + reason for return/exchange + photographs where relevant.`,
  },
  privacy: {
    title: "PRIVACY POLICY",
    content: `Eternal Order respects your privacy and is committed to protecting the personal information you share with us when you visit our website, place an order, contact us, subscribe to communications, or otherwise interact with our brand.
When you use our website, we may collect information such as your name, email address, mobile number, billing and shipping address, order details, transaction information, IP address, device/browser information, and information you voluntarily provide through customer support, forms, reviews, or other interactions.
We use this information to process and fulfil orders, arrange shipping and delivery, provide order updates, process exchanges and refunds, respond to customer queries, prevent fraud, improve our products and website, maintain business records, and, where permitted, send you promotional communications.
Where personal data is processed based on consent, customers may withdraw that consent, subject to processing that remains necessary for an existing transaction or is otherwise required or permitted by law. India’s Digital Personal Data Protection framework requires consent and notices to be clear and specific, and provides for withdrawal of consent and other data-principal rights.
We may share information only where reasonably necessary with service providers that help us operate our business, including payment gateways, Shopify or other website-service providers, analytics providers, communications platforms, and logistics partners such as NimbusPost and the courier partners allocated through its network. These parties may receive information necessary to process payments, fulfil orders, provide tracking, attempt delivery, manage NDRs, and process eligible reverse pickups.
We do not sell your personal information to advertisers.
Payment information may be processed directly by third-party payment gateways. Eternal Order may not store complete card or banking credentials where these are handled by the payment provider.
We use reasonable administrative and technical safeguards to protect personal information. However, no online transmission or storage system can be guaranteed to be completely secure.
We retain personal information only for as long as reasonably required for the purpose for which it was collected, including fulfilment, customer service, accounting, tax, fraud prevention, dispute resolution, and other legal or operational requirements.
Our website may use cookies and similar technologies for essential website functionality, cart/session management, analytics, performance measurement, and, where applicable, advertising or remarketing. You may control certain cookies through your browser or available cookie settings.
You may contact us to request access to, correction of, or other action regarding your personal data, or to withdraw applicable consent. As the relevant provisions of India’s DPDP framework come into force according to the notified implementation timeline, Eternal Order will apply the rights and processes required by applicable law. The DPDP Rules, 2025 were notified with phased commencement dates.
For privacy-related questions or requests, contact:
Eternal Order
Hyderabad, Telangana, India
Email: support@eternalorder.in
Phone/WhatsApp: +91-6304547946`,
  },
  terms: {
    title: "TERMS OF SERVICE",
    content:
      "By accessing and using the Eternal Order website, you agree to use the site for lawful purposes only.\nAll content, visuals, branding elements, and product designs on this website belong to Eternal Order unless stated otherwise. Unauthorized use, copying, or reproduction is not permitted.\nProduct pricing, availability, and website content may be updated or changed at any time without prior notice.\nEternal Order reserves the right to cancel or refuse orders in cases involving incorrect pricing, stock issues, or other operational limitations.",
  },
};
